import { render, staticRenderFns } from "./legal-waiting-collect-case-manage.vue?vue&type=template&id=4e75461f&scoped=true"
import script from "./legal-waiting-collect-case-manage.vue?vue&type=script&lang=ts"
export * from "./legal-waiting-collect-case-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e75461f",
  null
  
)

export default component.exports